// HomeCard: the one card of the ready-list home. The title sits inside (16/24/600), an optional note or link on its
// right, then the body. 12px corners, hairline, white, no shadow: the looks live in showcase-bridge.css under
// `/* ready list */`. DS request: the DS `Card` has fixed per-size boxes (xs 240x120 … xl 480x640), so a fluid card
// with a title row is drawn here until the DS has one.
import type { ReactNode } from 'react';

interface HomeCardProps {
  title: string;
  /** Beside the title, a blue count pill ("4 new"). */
  badge?: ReactNode;
  /** Right of the title: a count line, a legend or a quiet link. */
  right?: ReactNode;
  /** The body runs edge to edge (rows with their own padding and hairlines). */
  flush?: boolean;
  children: ReactNode;
  'data-testid'?: string;
}

export function HomeCard({ title, badge, right, flush, children, 'data-testid': testId }: HomeCardProps) {
  return (
    <section data-slot="home-card" data-testid={testId} aria-label={title} className="home-card">
      <header className="home-card-head">
        <div className="home-card-heading">
          <h2 className="home-card-title">{title}</h2>
          {badge != null && badge}
        </div>
        {right != null && <div className="home-card-right">{right}</div>}
      </header>
      <div className={flush ? 'home-card-body home-card-body-flush' : 'home-card-body'}>{children}</div>
    </section>
  );
}
